import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { getAllCompanies } from 'app/api/insuranceCompanyApi';
import { SortOrder } from 'primereact/api';
import { Checkbox } from 'primereact/checkbox';

const InsuranceCompanyTable: React.FC = () => {
  const [companies, setCompanies] = useState([]);
  const navigate = useNavigate(); // useNavigate instead of useHistory
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    getAllCompanies()
      .then(response => {
        setCompanies(response.data);
        setLoading(false);
      })
      .catch(error => {
        console.error('Error fetching career data:', error);
        setLoading(false);
      });
  }, []);

  // Redirect to the edit form (mask)
  const editCompany = company => {
    navigate(`/create-insurance-company/${company.id}`); // Use navigate instead of history.push
  };

  const actionBodyTemplate = rowData => {
    return <Button icon="pi pi-pencil" rounded outlined className="mr-2" onClick={() => editCompany(rowData)} />;
  };

  const logoFormatter = row => {
    if (row.logo) {
      return (
        <span className="d-flex">
          <img
            src={`https://system.nfagroup.eu/api/insurance-companies/logo/${row.id}`}
            style={{ maxWidth: '100px', height: 'auto' }}
            alt={row.id}
          />
        </span>
      );
    }

    return '';
  };

  const showCheckbox = zaplatene => {
    return <Checkbox disabled={true} style={{ marginLeft: '1rem' }} checked={zaplatene as boolean} />;
  };

  return (
    <div className="company-table">
      <h2>Spoločnosti</h2>
      <DataTable stripedRows sortField="name" sortOrder={SortOrder.ASC} loading={loading} value={companies} responsiveLayout="scroll">
        <Column field="logo" header="Logo" body={v => logoFormatter(v)}></Column>
        <Column field="name" header="Názov spoločnosti" sortable></Column>
        <Column
          field="generovatProviziePoImportePlatieb"
          header="Generovať provízie po importe platieb"
          sortable
          body={v => showCheckbox(v.generovatProviziePoImportePlatieb)}
        ></Column>
        <Column field="iban" header="IBAN" sortable></Column>
        <Column header="Akcie" body={actionBodyTemplate}></Column>
      </DataTable>
    </div>
  );
};

export default InsuranceCompanyTable;
